import {AuiIf, ComposerPrimitive, useAuiState} from '@assistant-ui/react';
import {IconButton} from '@wandb/components';
import React, {type FC} from 'react';

import {useNavContext} from '../NavContextProvider';
import {useNightModeRevertFilter} from './useNightModeRevertFilter';

const ComposerAction: FC = () => {
  const {params} = useNavContext();
  const hasProjectContext = !!params.entityName && !!params.projectName;
  const isEmpty = useAuiState(s => s.composer.isEmpty);

  return (
    <div className="flex">
      <AuiIf condition={s => !s.thread.isRunning}>
        <ComposerPrimitive.Send asChild>
          <IconButton
            isDisabled={isEmpty || !hasProjectContext}
            aria-label="send message"
            variant="primary"
            icon="up"
          />
        </ComposerPrimitive.Send>
      </AuiIf>
      <AuiIf condition={s => s.thread.isRunning}>
        <ComposerPrimitive.Cancel asChild>
          <IconButton aria-label="cancel query" icon="stop" />
        </ComposerPrimitive.Cancel>
      </AuiIf>
    </div>
  );
};

export const WBAgentComposer: FC = () => {
  const nightModeRevertFilter = useNightModeRevertFilter();

  return (
    <div className="relative">
      <div
        className="absolute inset-0 rounded bg-white dark:bg-moon-900 border dark:border-[#363C44]"
        style={{filter: nightModeRevertFilter}}
      />
      <ComposerPrimitive.Root className="relative flex flex-col gap-8 rounded border border-moon-250 bg-white p-12">
        <ComposerPrimitive.Input
          placeholder="Ask the W&B agent"
          className="w-full resize-none bg-transparent text-[15px] outline-none placeholder:text-moon-500"
          rows={1}
          autoFocus
          aria-label="Message input"
        />
        <div className="flex w-full justify-end">
          <ComposerAction />
        </div>
      </ComposerPrimitive.Root>
    </div>
  );
};
